/* eslint-disable import/no-unresolved,import/extensions,import/no-extraneous-dependencies */
import 'redactor'; // Redactor is global
import 'redactor-video';
import 'redactor-fontcolor';

export default () => {
  $R.options = {
    animation: false,
    buttons: ['bold', 'italic', 'fontcolor', 'ol', 'ul', 'link', 'image'],
    lang: 'sk',
    imageUpload: '/p2p/campaign/news/image-upload/',
    plugins: ['video', 'fontcolor'],
  };
};



// WEBPACK FOOTER //
// ./app/Assets/js/configureRedactor.js